import { cn } from '@/lib/cn'

type SpinnerProps = {
  /** `lg` for a full-column wait; `sm` sits inline with a line of text. */
  size?: 'sm' | 'lg'
  className?: string
  label?: string
}

export function Spinner({ size = 'sm', className, label = 'Loading' }: SpinnerProps) {
  return (
    <span
      role="status"
      aria-label={label}
      className={cn('spinner', size === 'lg' && 'spinner--lg', className)}
    />
  )
}

/**
 * Centred spinner for auth bootstraps that have nothing to show yet —
 * RequireAuth while the userManager hydrates, CallbackPage during the code
 * exchange. Sits in the content column so the brand row and foot stay put
 * while it spins.
 */
export function FullPageSpinner({ label = 'Loading' }: { label?: string }) {
  return (
    <div className="bootspinner" aria-live="polite">
      <Spinner size="lg" label={label} />
    </div>
  )
}
